import axios from '../http/axios';
import { PORTAL_SERVICOS_BACKEND } from '../constants/environment';

const BASE_URL_SERVICO = `${PORTAL_SERVICOS_BACKEND}/frontend/v1/servico`

export default {
  consultarPorCodigo: (codigo) => {
    return axios
      .get(`${BASE_URL_SERVICO}/consultar/${codigo}`)
      .then(res => { return res.data; });
  },
  consultarPorFiltro: (filtro) => {
    if (!filtro.page) {
      filtro.page = 0
		}
		if(!filtro.size){
			filtro.size = 5
		}
    return axios
      .post(`${BASE_URL_SERVICO}/consultar`, filtro)
      .then(res => { return res.data; });
  },
  salvar: (servico) => {
    return axios
      .post(`${BASE_URL_SERVICO}/salvar`, servico)
      .then(res => { return res.data; });
  },
  remover: (codigo) => {
    return axios
      .delete(`${BASE_URL_SERVICO}/remover`, { data: { codigo } })
      .then(res => { return res.data; });
  }
};
